import React from 'react';
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';


export default class CalltoAction extends React.Component{
    render(){
	var show = false;
	if(show){
	return(
	    <div className="section dark">
		<Grid>
		    <Row>
			<Col xs={10} xsOffset={1} md={6} mdOffset={0} xl={6} xlOffset={3}>
				    <h2 style={{marginTop: 0}} className="title">
					Hunger Action Series 2018
				    </h2>
				    <Typography variant="subheading" className="byline">
					March 23 to April 7
				    </Typography>
				    <Typography variant="body1">
					Two weeks of curated events that unify and celebrate all the efforts our students, faculty, administrators, and community members do every day to end college hunger.
				    </Typography>
				    <div style={{display: 'flex', flex: 1, justifyContent: 'center', marginTop: "1rem"}}>
					<Link to="/hunger-action-series-2018"
					      style={{fontFamily: "Nunito", border: "1px solid"}}
					      className="hover">
					    Learn More
					</Link>
				    </div>

			    
			</Col>
		    </Row>
		</Grid>
	    </div>
	);
	}else{
	    return (<div />);
	}
    }
}



// WEBPACK FOOTER //
// ./src/components/splash/call-to-action/index.jsx